import { DEFAULT_REGION } from '@/modules/pmt/constants/affiliate.constants';
import { AffiliateBadgeType, type AmazonLocale, type ProductBadge } from '../interfaces';

const AmazonLocalesMapping: Record<string, AmazonLocale> = {
  US: 'US',
  GB: 'UK',
  UK: 'UK',
  DE: 'DE',
};

export const getAmazonRegionFromCountry = (country?: string): AmazonLocale => {
  return (country && AmazonLocalesMapping[country]) || DEFAULT_REGION;
};

export const mapBadgeType = (badge: ProductBadge): AffiliateBadgeType | undefined => {
  const lowerBadge = badge.toLowerCase().trim();

  if (lowerBadge === 'limited time deal') {
    return AffiliateBadgeType.LimitedTimeDeal;
  }
  if (lowerBadge === "amazon's choice") {
    return AffiliateBadgeType.AmazonChoice;
  }
  if (lowerBadge === 'prime') {
    return AffiliateBadgeType.Prime;
  }
  if (lowerBadge === 'coupon') {
    return AffiliateBadgeType.Coupon;
  }

  return undefined;
};
